import Vue from 'vue'
import router from '../router'


const actions = {
  goBack({commit, state}){
    router.go(-1)
  },
  goUsers({commit, state}){
    router.push({ name: 'userslist'})
  },
  goNewUser({commit, state}){
    router.push({ name: 'usernewform'})
  },
  goEditUser({commit, state},userId){
    router.push({ name: 'usereditform', params: { userID: userId }})
  },
  goComplexes(context){
    router.push({ name: 'complexeslist'})
  },
  goNewComplex(context){
    router.push({ name: 'complexnewform'})
  },
  goEditComplex(context, complexID){
    router.push({ name: 'complexeditform', params: { complexID: complexID }})
  },
  goTeams(context){
    router.push({ name: 'teamslist'})
  },
  goNewTeam(context){
    router.push({ name: 'teamnewform'})
  },
  goEditTeam(context, teamID){
    router.push({ name: 'teameditform', params: { teamID: teamID }})
  },
  goFields(context){
    router.push({ name: 'fieldslist'})
  },
  goNewField(context){
    router.push({ name: 'fieldnewform'})
  },
  goEditField(context, id){
    router.push({ name: 'fieldeditform', params: { id: id }})
  },
  goNewTournament(context){
    router.push({ name: 'tournamentform' })
  },
  goEditTournament(context, tournamentID) {
    router.push({ name: 'tournamenteditform', params: {tournamentID: tournamentID} })
  },
  goTournamentRegistrations(context, tournamentID) {
    router.push({ name: 'tournamentregistrations', params: {tournamentID: tournamentID} })
  },
  goTournaments(context){
    router.push({ name: 'tournamentslist'})
  },
  goSponsorships() {
    router.push({ name: 'sponsorships' });
  },
  goEditSponsorship( context, id ) {
    router.push({ name: 'editsponsorship', params: { id } });
  },
  goNewSponsorship() {
    router.push({ name: 'sponsorshipsform' });
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/routeractions.js